/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { RecoverPassword } from './components/RecoverPassword'
import { DefinirSenha } from './components/DefinirSenha'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div className="row col-md-12">
      <div className="col-md-8 d-flex flex-wrap align-items-center" style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/login.png')})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        height: '100vh'
      }}>

        <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-branco.png')} style={{ margin: '0 auto', maxWidth: '40%' }} />
      </div>
      <div className='col-md-2 position-x-center d-flex'>
        {/* begin::Content */}
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
          {/* begin::Logo */}
          <a href='#' className='mb-12'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-45px' />
          </a>
          {/* end::Logo */}
          {/* begin::Wrapper */}
          <div className='w-lg-400px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
            <Switch>
              <Route path='/login' component={Login} />
              <Route path='/definir-senha' component={DefinirSenha} />
              <Route path='/recuperar-senha' component={RecoverPassword} />
              <Route path='/esqueci-minha-senha' component={ForgotPassword} />
              <Redirect from='/auth' exact={true} to='/login' />
              <Redirect to='/login' />
            </Switch>
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Content */}
      </div>
    </div>
  )
}
